import React from 'react'
import { useTranslation } from 'react-i18next'

type mainTitleProps={
    title:string
}

export default function MainTitle({title}:mainTitleProps) {
    const {t} = useTranslation();
  return (
    <h2 className=' capitalize text-Black font-black text-[20px]'>{t(title)}</h2>
  )
}
